export default __webpack_public_path__ + "static/media/arrow.d1fefcc1.svg";